import { render, staticRenderFns } from "./optional_org.vue?vue&type=template&id=45d5c89a&scoped=true"
import script from "./optional_org.vue?vue&type=script&lang=js"
export * from "./optional_org.vue?vue&type=script&lang=js"
import style0 from "./optional_org.vue?vue&type=style&index=0&id=45d5c89a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d5c89a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45d5c89a')) {
      api.createRecord('45d5c89a', component.options)
    } else {
      api.reload('45d5c89a', component.options)
    }
    module.hot.accept("./optional_org.vue?vue&type=template&id=45d5c89a&scoped=true", function () {
      api.rerender('45d5c89a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/process/views/process_map/components/business_context/form/optional_org.vue"
export default component.exports